import { apiRequest } from "./client";

export interface ParentConsentView {
  childName: string | null;
  childPhone: string | null;
  childEmail: string | null;
  childIsUnderAge: boolean;
  status: string;
  expiresAt: string;
  parentFirstName: string | null;
}

export interface ParentProgressView {
  childName: string;
  daysPractisedOfLastSeven: number;
  streakDays: number;
  lastMock: string | null;
  subjects: { subject: string; readiness: number; note: string }[];
}

/**
 * The parent surface. Unauthenticated by design — a parent has no account, and
 * the token in their SMS is the credential.
 */
export function fetchConsent(token: string): Promise<ParentConsentView> {
  return apiRequest<ParentConsentView>(`/api/parent/consent/${token}`);
}

export function approveConsent(token: string): Promise<{ status: string }> {
  return apiRequest<{ status: string }>(`/api/parent/consent/${token}/approve`, {
    method: "POST",
    body: {},
  });
}

export function declineConsent(token: string): Promise<{ status: string }> {
  return apiRequest<{ status: string }>(`/api/parent/consent/${token}/decline`, {
    method: "POST",
    body: {},
  });
}

/**
 * A child's progress, gated on the parent knowing their number or email.
 *
 * POST because that detail is a credential, and a credential in a URL ends up
 * in browser history and every proxy in between.
 */
export function fetchParentProgress(
  linkId: string,
  known: { childPhone: string } | { childEmail: string },
): Promise<ParentProgressView> {
  return apiRequest<ParentProgressView>(`/api/parent/progress/${linkId}`, {
    method: "POST",
    body: known,
  });
}
